import { getCheckoutSdk } from './checkout.svelte';
import { browser } from '$app/environment';

const getCountLegacy = () => {
  if (!browser) {
    return Promise.resolve(0);
  }

  return fetch('/checkout/get_cart_num_items', { method: 'GET' })
    .then((x) => x.json())
    .then((response) => {
      if (typeof response !== 'number') {
        throw new Error(`Unexpected response from server, expected number, got: ${response}`);
      }
      return response;
    });
};

let legacyCountPromise = $state<Promise<number>>(Promise.resolve(0));
const refreshCart = () => {
  const newCountPromise = getCountLegacy();
  newCountPromise.finally(() => {
    // only update the countPromise if the new promise is resolved
    // so that we show the "old" result until the new one is ready
    legacyCountPromise = newCountPromise;
  });
  return newCountPromise;
};

export function getShoppingCart() {
  const checkoutSdk = getCheckoutSdk();
  if (checkoutSdk) {
    return {
      get count() {
        return Promise.resolve(checkoutSdk.state.lines.length ?? 0);
      },
      refreshCart: () => Promise.resolve(checkoutSdk.state.lines.length ?? 0),
    };
  }

  return {
    get count() {
      if (!legacyCountPromise) {
        return refreshCart();
      }
      return legacyCountPromise;
    },
    refreshCart,
  };
}

export type ShoppingCartContext = {
  itemsInCart: Promise<number | null>;
  refreshCart: () => Promise<number>;
};
